import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { CanDeactivateGuard } from '../shared/deactivate-guard/deactivate.guard';

export const centralBookingRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
];
